"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PresentacionDelCurso() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="presentación-del-curso" className="bg-background pt-[120px] pb-16 lg:pb-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 rounded-[2rem] overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative w-full h-full min-h-[300px] lg:min-h-[600px] bg-muted">
            <AspectRatio ratio={4 / 3} className="h-full w-full lg:hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/poultry_farm_action.png" alt="Entorno avícola profesional" className="object-cover w-full h-full" />
              {}
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 to-transparent lg:hidden"></div>
            </AspectRatio>
            
            {}
            <div className="hidden lg:block absolute inset-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/poultry_farm_action.png" alt="Entorno avícola profesional" className="object-cover w-full h-full" />
              {}
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay"></div>
            </div>
          </div>

          {}
          <div className="bg-foreground p-8 md:p-12 lg:p-16 xl:p-20 flex flex-col justify-center relative z-10 -mt-6 lg:mt-0 rounded-t-[2rem] lg:rounded-t-none lg:rounded-l-none">
            {}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-secondary/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

            <div className="relative z-10 flex flex-col items-start">
              <Badge variant="outline" className="bg-secondary/10 text-secondary border-secondary/30 backdrop-blur-md mb-6 px-4 py-1.5 text-sm font-semibold tracking-wide uppercase flex items-center gap-2">
                <Sparkles className="size-4" />
                Nuevo Curso
              </Badge>

              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-sans font-extrabold uppercase tracking-[-0.02em] text-white leading-[1.1] mb-8">
                Producción<br />
                Avícola
              </h1>

              <p className="text-muted-foreground text-lg md:text-xl mb-10 max-w-md leading-relaxed">
                Domina las técnicas más avanzadas y eficientes en el manejo y producción de aves a nivel profesional.
              </p>

              <Link to="https://wa.me/59896344395" newTab className="w-full sm:w-auto">
                <Button size="lg" className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 h-14 px-8 text-lg font-bold rounded-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_25px_var(--color-secondary)] border border-secondary/50">
                  Inscribirse por WhatsApp
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}